import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LogIn } from 'src/app/models/user/login.model';
import { LoginService } from 'src/app/services/login/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loading: boolean = false;
  rucToCheck: string = ''; // Variable para almacenar el RUC ingresado por el usuario
  ruc: string = '';
  newCompanyId= '';

  signIn: LogIn = {
    idCompany: '',
    useEmail: '',
    password: '',
  };

  myForm: FormGroup = this.fb.group({
    idCompany: [''],
    useEmail: ['', [Validators.required]],
    password: ['', [Validators.required]],
  });

  constructor(
    private loginService: LoginService,
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {
    this.rucToCheck = '';
  }

  ngOnInit(): void {}

  loginUser() {
    let idRuc = this.newCompanyId;
    console.log('hiciste click')
    console.log('este en el idcompany',idRuc)
    this.signIn.idCompany = idRuc;
    this.signIn.useEmail = this.myForm.value.useEmail;
    this.signIn.password = this.myForm.value.password;

    if (
      this.signIn.idCompany.trim() == '' ||
      this.signIn.idCompany.trim() == null
    ) {
      return;
    }
    if (
      this.signIn.useEmail.trim() == '' ||
      this.signIn.useEmail.trim() == null
    ) {
      return;
    }

    if (
      this.signIn.password.trim() == '' ||
      this.signIn.password.trim() == null
    ) {
      return;
    }

    // Mostramos el loader
    this.loading = true;
    this.loginService.generateToken(this.signIn).subscribe({
      next: (data) => {
        this.loginService.setToken(data.token);
        this.loginService.getCurrentUser().subscribe({
          next: (res) => {
            this.loginService.setUser(res);
            if (
              this.loginService.getUserRole() == 'ROLE_ADMIN' ||
              this.loginService.getUserRole() == 'ROLE_USER'
            ) {
              this.router.navigate(['restaurant/table/list']);
            }
          },
          error: () => {
            this.toastr.error('Error al traer información del usuario', '');
            this.loading = false;
          },
          complete: () => {
            this.loading = false;
          },
        });
      },
      error: () => {
        this.toastr.error('Clave o usuario son incorrectos', '');
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
  verifyDocument() {
    this.loginService.getRucCompany(this.rucToCheck).subscribe(
      (response) => {
        console.log('Respuesta del servidor:', response);
        this.loginService.setCompany(response);
        this.newCompanyId = response.idCompany;
          console.log("este es el id",this.newCompanyId);

      },
      (error) => {
        error.status === 404
          this.toastr.error('RUC no encontrado', 'iNCORRECTO');
          console.log("RUC no existe");
      }
    );
  }
}
